import styled from "styled-components";
import {
  Grid as SemanticGrid,
  GridColumn,
  Input,
  Button as SemanticButton,
} from "semantic-ui-react";
import MaterialPagination from "@material-ui/lab/Pagination";
import { AiFillCloseCircle, AiOutlineSearch } from "react-icons/ai";

export const Container = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? "column-reverse" : "column")};

  ${(props) =>
    props.reverse
      ? `
    margin-top: 8px !important;
    & > *:not(:last-child) {
      margin-top: 8px !important;
    }
  `
      : `
    margin-bottom: 8px !important;
    & > *:not(:last-child) {
      margin-bottom: 4px !important;
    }
  `}
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SearchInput = styled(Input)`
  width: 100%;
  margin-right: 10px;
`;

export const Pagination = styled(MaterialPagination)`
  margin-left: auto;
  margin-right: auto;
  width: max-content;
`;

export const Grid = styled(SemanticGrid)`
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

export const Column = styled(GridColumn)`
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  padding: ${(props) => props.padding || "0 0 0 0"} !important;

  ${(props) =>
    props.horizontal &&
    `
    flex-direction: row !important;
    justify-content: space-between !important;
  `}
`;

export const SearchIcon = styled(AiOutlineSearch)`
  cursor: pointer;
`;

export const CleanSearchIcon = styled(AiFillCloseCircle)`
  cursor: pointer;
`;

export const Button = styled(SemanticButton)``;
